<!--
 * @Description: 
 * @Author: Mankeung
 * @Date: 2021-07-07 10:03:48
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-21 18:55:32
-->

<style lang="scss" scoped>
.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Left {
    width: auto;
    padding-right: 15px;

    &_List {
      display: flex;
      flex-direction: column;
      gap: 10px;
      margin-top: 20px;
    }
  }

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;
    border-left: 1px solid #ccc;
    padding-left: 15px;

    &_Top {
      display: flex;
      gap: 15px;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;
    }

    &_pagenation {
      margin: 40px auto;
    }

    ::v-deep .el-table th,
    ::v-deep .el-table td {
      text-align: center !important;
    }
  }
}
</style>
<template>
  <section>
    <div class="role">
      <div class="roleRight" style="border-left: 0">
        <div class="roleRight_Top">
          <el-input
              v-if="searchShow"
              clearable
              v-model="search.searchKey"
              clas="input_search"
              placeholder="搜索关键字"
              @keyup.enter.native="SearchPostList"
          ></el-input>
          <el-select v-if="searchShow" v-model="search.status" clearable placeholder="请选择">
            <el-option label="正常" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
          <el-button v-if="searchShow" size="medium" type="primary" @click="SearchPostList"
          >查询
          </el-button
          >
          <el-button
              v-if="addShow"
              size="medium"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table v-loading="loading" :data="tableData" size="medium" border>
            <el-table-column
                fixed
                label="序号"
                prop="postId"
                type="index"
                width="100"
            >
              <template slot-scope="scope">
                <span>{{
                    (page.pageNo - 1) * page.pageSize + scope.$index + 1
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="名称" min-width="50">
            </el-table-column>
            <el-table-column prop="seq" label="排序" align="center" width="100">
            </el-table-column>
            <el-table-column prop="descr" label="说明" min-width="50">
            </el-table-column>
            <el-table-column prop="status" label="状态" width="100">
              <template slot-scope="scope">
                <el-switch
                    :disabled="statusShow"
                    v-model="scope.row.status"
                    :active-value="1"
                    :inactive-value="0"
                    @change="handleSwitch(scope.$index)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column v-if="editShow || deleteShow" fixed="right" label="操作">
              <template slot-scope="scope">
                <el-button
                    v-if="editShow"
                    @click="handleClick('change', scope.row)"
                    plain
                    size="small"
                >修改
                </el-button
                >
                <el-button
                    v-if="deleteShow"
                    type="primary"
                    plain
                    size="small"
                    @click="del(scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="roleRight_pagenation">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.pageNo"
              :page-sizes="[PAGE_SIZE, 15, 20, 25]"
              :page-size="page.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 编辑弹框 -->
    <el-dialog
        title="新增/编辑岗位组信息"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="460px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <!-- 修改岗位 -->
          <el-form-item
              class="item"
              label="名称："
              prop="name"
          >
            <el-input
                clearable
                placeholder="请填写岗位名称"
                v-model="params.name"
            ></el-input>
          </el-form-item>
          <el-form-item
              class="item"
              label="排序："
          >
            <el-input
                clearable
                placeholder="请填写排序"
                v-model="params.seq"
            ></el-input>
          </el-form-item>
          <el-form-item class="item" label="说明：">
            <el-input
                maxlength="200"
                :rows="4"
                placeholder="最长为200个字符"
                type="textarea"
                v-model="params.descr"
            ></el-input>
          </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>
<script>
import {PAGE_SIZE} from "@/config";

export default {
  data() {
    return {
      PAGE_SIZE,
      loading: false,
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      defaultPropsPos: {
        label: "name",
      },
      defaultProps: {
        children: "menus",
        label: "name",
      },
      treeList: [],
      treeList_one: [],
      optionList: [
        {
          value: "1",
          label: "修改",
        },
        {
          value: "2",
          label: "删除",
        },
      ],
      search: {},

      value1: "", //select2
      value2: true,
      dialogVisible: false, //弹出框显示隐藏
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        name: [
          {required: true, message: "请填写名称", trigger: "change"},
          {max: 10, message: "最多10个字符"},
        ],
        value1: [
          {required: true, message: "请选择操作类型", trigger: "change"},
        ],
      }, //表单验证提示
      tableData: [], //二级--岗位列表
      trees: {
        tree: true,
      },
      searchShow: false,
      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true
    };
  },
  async created() {
    this.getRoleListTree();
    // this.getRoleList();
    await this.getPermissionButtonList()
    // this.getPermissionData(); //获取所有菜单权限项目
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
      }
    },
    search: {
      handler(val) {
      },
      deep: true,
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'system:staff:query') {
            this.searchShow = true
          }
          if (item.code == 'system:staff:add') {
            this.addShow = true
          }
          if (item.code == "system:staff:delete") {
            this.deleteShow = true
          }
          if (item.code == "system:staff:edit") {
            this.editShow = true
          }
          if (item.code == "system:staff:status") {
            this.statusShow = false
          }
        })
      }
    },
    SearchPostList() {
      this.page.pageNo = 1
      this.getRoleListTree()
    },
    /**
     *  get role List  //and table  //left menu  //search
     */
    async getRoleListTree(data, checked) {
      // paging=false&
      let http = `/post/list`;
      if (checked) {
        let checks = this.$refs.postTree.getCheckedKeys();
        let temp = "";
        for (const i in checks) {
          temp += `&postIds=${checks[i]}`;
        }
        http = `${http}${temp}`;
      }
      //岗位列表
      this.loading = true;
      const {data: resData} = await this.$get(http, {
        params: {...this.search, ...this.page},
      });
      this.loading = false;
      this.tableData = resData.data;
      this.page.count = resData.page.count;
    },
    async getRoleList() {
      //岗位组--树
      const {data: resData} = await this.$get(`/post/list?paging=false&nodeLevel=1`);
      this.treeList = resData.data;
    },
    // async getPermissionData() {
    //   const { data: resData } = await this.$get("/menus");
    //   if (resData.result != 200) return;
    //   this.permissionData = resData.data;
    // },
    //switch状态改变 --接口 修改岗位状态
    handleSwitch(index) {
      this.$put(`/post/info/status/${this.tableData[index].postId}`).then(res => {
        if (res.data.result == 200) {
          this.$message.success('操作成功')
        }
      });
    },

    // 弹窗
    handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;
      if (type == "change") {
        //修改  change
        this.params = {
          postId: row.postId,
          name: row.name,
          descr: row.descr,
          parentId: row.parentId,
          seq: row.seq
        };
      } else {
        //添加
        this.params = {};
      }
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        let passData = {
          name: this.params.name,
          parentId: this.params.parentId,
          postId: this.params.postId,
          descr: this.params.descr,
          seq: this.params.seq,
        };
        if (!valid) return;
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "addgroup" || this.clickType == "addNext") {
            const {data: resData} = await this.$post("/post/info", passData, {
              headers: {
                isLoading: true,
              },
            });
            if (resData.result != 200) return;
            this.getRoleListTree(); //重新获取数据
            this.dialogVisible = false; //弹窗隐藏
            this.$message.success("添加成功!");
          } else if (this.clickType == "change") {
            //修改岗位
            const {data: resData} = await this.$put(
                "/post/info",
                passData,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.getRoleListTree(); //重新获取数据
            this.dialogVisible = false; //弹窗隐藏
            this.$message.success("修改成功!");
          }
        });
      });
    },

    //删除
    del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$delete(
            `/post/info/${row.postId}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getRoleListTree();
        this.$message.success("删除成功!");
      });
    },

    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getRoleListTree();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getRoleListTree();
    },

    // 编辑岗位 组时候--change事件 --触发获取其详情
    async selectTrigger(postId) {
      if (this.clickType == "edit") {
        const {data: res} = await this.$get(`/post/info/${postId}`);
        this.params = res.data;
      }
    },
  },
};
</script>
